import { Consent, Visibility } from '../../common/Enums'
import { load, save } from '../../repositories/SettingsRepository'
import Dispatcher, { IActionPayload } from '../Dispatcher'
import SettingsStore, { ISettingsStoreMemento } from './SettingsStore'

// Types associated with Board Actions
const SETTINGS_LOADED = 'SETTINGS_LOADED'
const SETTINGS_AUTOSAVE_CHANGED = 'SETTINGS_AUTOSAVE_CHANGED'
const SETTINGS_BOARD_FOCUS_ON = 'SETTINGS_BOARD_FOCUS_ON'
const SETTINGS_BOARD_FOCUS_OFF = 'SETTINGS_BOARD_FOCUS_OFF'
const SETTINGS_SAVED = 'SETTINGS_SAVED'
const SETTINGS_INFO_VISIBLE = 'SETTINGS_INFO_VISIBLE'
const SETTINGS_INFO_HIDDEN = 'SETTINGS_INFO_HIDDEN'
const SETTINGS_SET_COOKIE_CONSENT = 'SETTINGS_SET_COOKIE_CONSENT'

/**
 * Dispatches action containing settings store state to load.
 * if defaults then uses default values, else loads from repository.
 * @param loadDefaults true, uses default values else loads from repo
 */
function loadSettings(loadDefaults: boolean) {
    let payload: ISettingsStoreMemento = {} as ISettingsStoreMemento
    if (!loadDefaults) payload = load()
    // if loading defaults then will be true
    // if not loading defaults but no data to load, also true
    if (Object.keys(payload).length === 0)
        payload = {
            autoSave: false,
            focus: {
                isFocused: false,
                boardId: -1,
            },
            infoState: Visibility.Visible,
            cookieConsent: Consent.Undecided,
        }
    Dispatcher.dispatch({
        actionType: SETTINGS_LOADED,
        payload,
    } as IActionPayload<ISettingsStoreMemento>)
}

/**
 * Saves the settings store to the repository
 */
function saveSettings() {
    const settingsStore = SettingsStore.GetInstance()
    save(settingsStore.Memento)
    Dispatcher.dispatch({
        actionType: SETTINGS_SAVED,
    })
}

/**
 * Dispatches action contianing state to change autosave setting to.
 * @param enabled true if enabled else false
 */
function autoSaveChanged(enabled: boolean) {
    Dispatcher.dispatch({
        actionType: SETTINGS_AUTOSAVE_CHANGED,
        payload: enabled,
    } as IActionPayload<boolean>)
}

/**
 * Dispatches action containing id of board to focus on
 * @param boardId Board to focus on
 */
function enableFocus(boardId: number) {
    Dispatcher.dispatch({
        actionType: SETTINGS_BOARD_FOCUS_ON,
        payload: boardId,
    } as IActionPayload<number>)
}

/**
 * Dispatches action to instruct focus feature to disable
 */
function disableFocus() {
    Dispatcher.dispatch({
        actionType: SETTINGS_BOARD_FOCUS_OFF,
    })
}

/**
 * Dispatches action to instruct info panel to be shown
 */
function showInfo() {
    Dispatcher.dispatch({
        actionType: SETTINGS_INFO_VISIBLE,
    })
}

/**
 * Dispatches action to instruct info panel to be hidden
 */
function hideInfo() {
    Dispatcher.dispatch({
        actionType: SETTINGS_INFO_HIDDEN,
    })
}

/**
 * Dispatches action when user accepts or declines cookies
 * @param {Consent} value Accept or Decline
 */
function setCookieConsent(value: Consent) {
    Dispatcher.dispatch({
        actionType: SETTINGS_SET_COOKIE_CONSENT,
        payload: value,
    } as IActionPayload<Consent>)
}

export {
    SETTINGS_LOADED,
    SETTINGS_AUTOSAVE_CHANGED,
    SETTINGS_BOARD_FOCUS_ON,
    SETTINGS_BOARD_FOCUS_OFF,
    SETTINGS_SAVED,
    SETTINGS_INFO_HIDDEN,
    SETTINGS_INFO_VISIBLE,
    SETTINGS_SET_COOKIE_CONSENT,
    loadSettings,
    saveSettings,
    autoSaveChanged,
    enableFocus,
    disableFocus,
    showInfo,
    hideInfo,
    setCookieConsent,
}
